import ComplianceAlertsReducer from "../reducers/ComplianceAlertsReducer";
import BaseAction from "./BaseAction";

class ComplianceAlertsAction extends BaseAction {}

const action = new ComplianceAlertsAction(ComplianceAlertsReducer);

export default action;
